import type { StyleRule } from '@archipro-design/aria';
import {
    SubheaderClassName,
    archizeenTileSlotClassNames,
    avatarClassName,
    labelClassName,
    productTileClassName,
    productTileSlotClassNames,
    professionalTileClassName,
    professionalTileSlotClassNames,
    projectTileClassName,
    projectTileSlotClassNames,
} from '@archipro-design/aria';
import { archizeenTileClassName } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';

import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const Wrapper: StyleRule = () => ({});

export const CarouselsRow: StyleRule = ({ theme }) => ({
    borderTop: `1px solid ${theme.siteVariables.colors.grey['150']}`,
    padding: pxArrayToRem([42, 0, 38, 0]),

    [`&:first-child`]: {
        borderTop: 'none',
        padding: pxArrayToRem([20, 0, 49, 0]),
    },
});
export const CarouselContainer: StyleRule = () => ({
    display: 'flex',
    flex: 1,
    gap: pxToRem(6),
    padding: pxArrayToRem([0, 18]),
    'overscroll-behavior-x': 'none',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
        height: 0,
        display: 'none',
    },
});
export const ViewMore: StyleRule<{ itemType: string }> = ({
    theme,
    itemType,
}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: pxToRem(16),
    textTransform: 'uppercase',
    color: 'inherit',

    width: pxToRem(131),
    minWidth: pxToRem(131),
    border: '1px solid #727272',
    ...theme.siteVariables.textStyles.Heading.Roman55,
    height: pxToRem(158),

    ...(itemType === 'Professionals' && {
        height: pxToRem(128),
    }),

    ...(itemType === 'Articles' && {
        height: pxToRem(136),
    }),
});

export const CarouselsRowHeader: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),
    marginBottom: pxToRem(18),
    [`&.${captionClassName}`]: {
        ...theme.siteVariables.textStyles.Heading.Medium65,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
});

export const ItemContainer: StyleRule = ({ theme }) => {
    return {
        [`& .${archizeenTileClassName}`]: {
            border: 'none !important',
            gridTemplateColumns: `[image] 118rem [info] 131rem`,
            padding: `0 ${pxToRem(8)} 0 0 !important`,
            width: `calc(100vw - ${pxToRem(82)})`,

            [`& .${archizeenTileSlotClassNames.title}`]: {
                [`&.${SubheaderClassName}`]: {
                    marginTop: '0',
                },
            },

            [`& .${archizeenTileSlotClassNames.content}`]: {
                padding: pxArrayToRem([23, 0, 15]),

                [`& .${SubheaderClassName}`]: {
                    '-webkit-line-clamp': 2,
                },

                [`& .${captionClassName}`]: {
                    marginBottom: pxToRem(3),
                },
            },
        },

        [`& .${productTileClassName}`]: {
            [`& .${productTileSlotClassNames.content}`]: {
                padding: pxArrayToRem([0, 0, 0, 10]),
                marginTop: pxToRem(12),
            },
            [`& .${productTileSlotClassNames.product}`]: {
                WebkitLineClamp: 1,
                ...theme.siteVariables.textStyles.Text.Roman55,
            },
            [`& .${productTileSlotClassNames.professional}`]: {},
            [`& .${productTileSlotClassNames.priceContainer}`]: {
                [`& .${labelClassName}`]: {
                    marginRight: '0.5ch',
                },
            },
        },
        [`& .${projectTileClassName}`]: {
            [`& .${projectTileSlotClassNames.professionalName}`]: {
                fontSize: pxToRem(14),
                lineHeight: pxToRem(18),
                marginTop: pxToRem(12),
                paddingLeft: pxToRem(10),
            },
            [`& .${projectTileSlotClassNames.projectName}`]: {
                fontSize: pxToRem(12),
                paddingLeft: pxToRem(10),
                color: theme.siteVariables.colors.charcoal['250'],
            },
        },
        [`& .${professionalTileClassName}`]: {
            [`& .${professionalTileSlotClassNames.content}`]: {
                padding: pxArrayToRem([0, 10]),

                [`& .${professionalTileSlotClassNames.logo}`]: {
                    [`&.${avatarClassName}`]: {
                        height: pxToRem(63),
                        width: pxToRem(63),
                        minWidth: pxToRem(63),
                        marginBottom: pxToRem(12),
                    },
                },
                [`& .${professionalTileSlotClassNames.title}`]: {
                    fontSize: pxToRem(14),
                    lineHeight: pxToRem(18),
                    marginBottom: pxToRem(2),
                },
                [`& .${professionalTileSlotClassNames.category}`]: {
                    fontSize: pxToRem(12),
                    lineHeight: pxToRem(12),
                    marginBottom: pxToRem(2),
                    color: theme.siteVariables.colors.charcoal['250'],
                },
                [`& .${professionalTileSlotClassNames.location}`]: {
                    fontSize: pxToRem(12),
                    lineHeight: pxToRem(12),
                },
                [`& .${professionalTileSlotClassNames.services}`]: {
                    fontSize: pxToRem(12),
                    lineHeight: pxToRem(12),
                    marginTop: pxToRem(6),
                    [`& .${captionClassName}`]: {
                        fontSize: 'inherit',
                        lineHeight: 'inherit',
                    },
                },
            },
        },
    };
};
